import React from "react";
import ManagementExpo from "./managementExpo";
import ManagementValueExpo from "./managementValueExpo";
import InspectionExpo from "./inspectionExpo";
import RefrigerationExpo from "./refrigarationExpo";
import CongelationExpo from "./congelationExpo";

const vistasExpo = {
  management: ManagementExpo,
  value_management: ManagementValueExpo,
  inspection: InspectionExpo,
  refrigeration: RefrigerationExpo,
  congelation: CongelationExpo,
};

function VistaDetalleExpo({ concepto, onClose, tarifas, actualizarTarifa }) {
  const Componente = vistasExpo[concepto];

  if (!Componente) {
    return <div>Vista no encontrada</div>;
  }

  return (
    <Componente
      onClose={onClose}
      valorActualExpo={tarifas[concepto]}
      actualizarTarifa={actualizarTarifa}
      concepto={concepto}
    />
  );
}

export default VistaDetalleExpo;
